// extracted by mini-css-extract-plugin
export var chip = "_5f-0";
export var filterDropdown = "_5f-5";
export var filterItem = "_5f-6";
export var icon = "_5f-1";
export var removeButton = "_5f-3";
export var removeIcon = "_5f-4";
export var separator = "_5f-2";